import { getDocumentOrThrow } from "@faire/web/common/globals/getDocument";
import { getWindow } from "@faire/web/common/globals/getWindow";

export const loadScript = async (
  src: string,
  globalIdentifier: string
): Promise<void> => {
  // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
  if (getWindow()[globalIdentifier]) {
    // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
    return getWindow()[globalIdentifier];
  }

  return new Promise((resolve, reject) => {
    const script = getDocumentOrThrow().createElement("script");
    script.id = globalIdentifier;
    script.onerror = reject;
    script.onload = () => {
      // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
      resolve(getWindow()[globalIdentifier]);
    };
    script.src = src;

    getDocumentOrThrow().body.appendChild(script);
  });
};
